import React, { useState } from "react";
import { useAuth } from "../../store/context/AuthContext";
import { Button, Descriptions, Flex } from "antd";
import CustomModal from "../../components/modal/CustomModal";
import PasswordInput from "../../components/input/PasswordInput";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import ConfirmModal from "../../components/modal/ConfirmModal";

const Profile = () => {
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { removeAuth, user } = useAuth();
  const toast = useToast();

  const passwordHandler = async () => {
    const res = await api.change_password(user.id, {
      oldPassword,
      newPassword: password,
    });
    // console.log("password res --->", res);
    if (res.status === 200) {
      toast("Нууц үг амжилттай солигдлоо", "success");
      clearHandler();
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const logout = async () => {
    const res = await api.logout();
    // console.log("logout res --->", res);
    if (res.status === 200) {
      await removeAuth();
      toast("Системээс гарлаа", "info");
    } else {
      // console.error("Logout error:", res);
      toast("Системээс гарахад алдаа гарлаа", "error");
    }
  };

  const clearHandler = () => {
    setVisible(false);
    setOldPassword("");
    setPassword("");
    setConfirmPassword("");
  };

  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasMinLength = /^.{8,}$/.test(password);

  return (
    <Flex vertical gap={"20px"}>
      <h3 style={{ margin: 0 }}>Профайл</h3>

      <Descriptions
        bordered
        column={1}
        size="middle"
        style={{ maxWidth: "50vw" }}
      >
        <Descriptions.Item label="И-мэйл">
          {user?.email || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Нэр">{user?.name || "-"}</Descriptions.Item>
        <Descriptions.Item label="Эрх">{user?.role || "-"}</Descriptions.Item>
        <Descriptions.Item label="Бүртгэл үүссэн">
          {new Date(user?.created_at).toLocaleString("mn-MN")}
        </Descriptions.Item>
      </Descriptions>
      <Button
        variant="filled"
        // color="danger"
        style={{ width: "200px" }}
        onClick={() => setVisible(true)}
      >
        Нууц үг солих
      </Button>
      <Button
        variant="filled"
        color="danger"
        style={{ width: "200px" }}
        onClick={() => setShowModal(true)}
      >
        Гарах
      </Button>

      <CustomModal
        title={"Нууц үг солих"}
        open={visible}
        onCancel={() => clearHandler()}
        onOk={passwordHandler}
      >
        <Flex vertical gap={"10px"}>
          <PasswordInput
            title={"Хуучин нууц үг"}
            value={oldPassword}
            onChange={setOldPassword}
            required
            autoFocus
          />
          <PasswordInput
            title={"Шинэ нууц үг"}
            value={password}
            onChange={setPassword}
            required
          />
          <PasswordInput
            title={"Нууц үг давтах"}
            value={confirmPassword}
            onChange={setConfirmPassword}
            required
            autoFocus
          />
          <Flex vertical>
            <ul style={{ margin: 0, padding: "0 0 0 15px" }}>
              <li
                style={{
                  color: hasMinLength ? "#0066cc" : "#f00",
                  fontSize: "12px",
                }}
              >
                8 буюу түүнээс дээш тэмдэгт
              </li>
              <li
                style={{
                  color: hasUppercase ? "#0066cc" : "#f00",
                  fontSize: "12px",
                }}
              >
                Ядаж нэг том үсэг
              </li>
              <li
                style={{
                  color: hasLowercase ? "#0066cc" : "#f00",
                  fontSize: "12px",
                }}
              >
                Ядаж нэг жижиг үсэг
              </li>
              <li
                style={{
                  color: hasNumber ? "#0066cc" : "#f00",
                  fontSize: "12px",
                }}
              >
                Ядаж нэг тоо
              </li>
              {password !== confirmPassword && confirmPassword.length > 0 && (
                <li
                  style={{
                    color: password === confirmPassword ? "#0066cc" : "#f00",
                    fontSize: "12px",
                  }}
                >
                  Нууц үг таарахгүй байна
                </li>
              )}
            </ul>
          </Flex>
        </Flex>
      </CustomModal>

      <ConfirmModal
        variant="warning"
        title="Системээс гарах уу?"
        showModal={showModal}
        setShowModal={setShowModal}
        submitHandler={logout}
      />
    </Flex>
  );
};

export default Profile;
